import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(["idWorldWorkPricing"]),
        getBySupplier: state => id => {
            return state.objs.filter(pricing => pricing.supplier === id && pricing.project === '');
        },
        getByCustomer: state => id => {
            return state.objs.filter(pricing => pricing.customer === id && pricing.project === '');
        },
        getByContact: state => id => {
            return state.objs.find(pricing => pricing.contact === id);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(["idWorldWorkPricing"]),
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldWorkPricing']),
    },
}